import { themeConfig, demographicColorRamps } from '../../config/theme-config';

export const datasetProfiles = [
  {
    label: 'Service Coverage',
    source: 'Provider reported data as of 6/30/2022, submitted directly to MBI or to the FCC as BDC filings',
    percentKeys: [
      'location_availability_unserved_pct',
      'location_availability_underserved_pct',
      'location_availability_served_pct',
    ],
    countKeys: [
      'location_availability_unserved',
      'location_availability_underserved',
      'location_availability_served',
    ],
    labels: [
      'Unserved',
      'Underserved',
      'Served',
    ],
    colorRamp: themeConfig['Service Coverage 25/3'].ramp.map(({ fillColor }) => `rgba(${fillColor.join(',')})`).slice(0, 3),
  },
  {
    label: 'Maximum Speed',
    source: 'Provider reported data as of 6/30/2022, submitted directly to MBI or to the FCC as BDC filings',
    percentKeys: [
      'location_max_25x3_pct',
      'location_max_100x20_pct',
      'location_max_100x100_pct',
      'location_max_1000x1000_pct',
    ],
    countKeys: [
      'location_max_25x3',
      'location_max_100x20',
      'location_max_100x100',
      'location_max_1000x1000',
    ],
    labels: [
      '25/3 Mbps',
      '100/20 Mbps',
      '100/100 Mbps',
      '1000/1000 Mbps',
    ],
    colorRamp: Object.values(themeConfig['Maximum Speed'].unique).map(({ fillColor }) => `rgba(${fillColor.join(',')})`).slice(0, 4),
  },
  {
    label: 'Number of Providers',
    source: 'Provider reported data as of 6/30/2022, submitted directly to MBI or to the FCC as BDC filings',
    percentKeys: [
      'location_providers_0_pct',
      'location_providers_1_pct',
      'location_providers_2_pct',
      'location_providers_3_pct',
      'location_providers_4plus_pct',
    ],
    countKeys: [
      'location_providers_0',
      'location_providers_1',
      'location_providers_2',
      'location_providers_3',
      'location_providers_4plus',
    ],
    labels: [
      '0 Providers',
      '1 Provider',
      '2 Providers',
      '3 Providers',
      '4+ Providers',
    ],
    colorRamp: themeConfig['Number of Providers'].ramp.map(({ fillColor }) => `rgba(${fillColor.join(',')})`).slice(0, 5),
  },
  {
    label: 'Internet Subscriptions',
    source: '2021 ACS 5-year',
    percentKeys: [
      'household_internet_none_pct',
      'household_internet_dial_up_pct',
      'household_internet_broadband_any_pct',
    ],
    countKeys: [],
    labels: [
      'None',
      'Dial Up',
      'Broadband',
    ],
    colorRamp: demographicColorRamps['Internet Subscriptions'].colorRamp.slice(0, 3),
  },
  {
    label: 'Household Income',
    source: '2021 ACS 5-year',
    percentKeys: [
      'household_income_less_35_pct',
      'household_income_35_50_pct',
      'household_income_50_100_pct',
      'household_income_100_150_pct',
      'household_income_150_plus_pct',
    ],
    countKeys: [],
    labels: [
      '< 35k',
      '35k - 50k',
      '50k - 100k',
      '100k - 150k',
      '> 150k',
    ],
    colorRamp: demographicColorRamps['Household Income'].colorRamp.slice(0, 5),
  },
  {
    label: 'Race',
    source: '2020 Decennial Census',
    percentKeys: [
      'pop_race_americanindian_alaskanative_pct',
      'pop_race_asian_pct',
      'pop_race_black_pct',
      'pop_race_hawaiian_pacificislander_pct',
      'pop_race_multi_pct',
      'pop_race_other_pct',
      'pop_race_white_pct',
    ],
    countKeys: [],
    labels: [
      'American Indian/Alaskan Native',
      'Asian',
      'Black',
      'Hawaiian/Pacific Islander',
      'Multiple',
      'Other',
      'White',
    ],
    colorRamp: demographicColorRamps.Race.colorRamp.slice(0, 7),
  },
  {
    label: 'Age',
    source: '2021 ACS 5-year',
    percentKeys: [
      'pop_age_under_20_pct',
      'pop_age_20_39_pct',
      'pop_age_40_59_pct',
      'pop_age_60_79_pct',
      'pop_age_80_plus_pct',
    ],
    countKeys: [],
    labels: [
      '< 20',
      '20 - 39',
      '40 - 59',
      '60 - 79',
      '80+',
    ],
    colorRamp: demographicColorRamps.Age.colorRamp.slice(0, 5),
  },
];

export const allPercentDataKeys = datasetProfiles.reduce((acc, { percentKeys }) => [...acc, ...percentKeys], []);
export const allPercentDataKeyLabels = datasetProfiles.reduce((acc, { labels }) => [...acc, ...labels], []);
export const allCountDataKeys = datasetProfiles.reduce((acc, { countKeys }) => [...acc, ...countKeys], []);
export const uniqueColorsArray = datasetProfiles.reduce((acc, { colorRamp }) => [...acc, ...colorRamp], []);
